import { useEffect, useState } from "react";

/**
 * Trailing-edge debounce for search boxes: a list query per keystroke is a
 * rate-limit budget spent on results nobody read.
 */
export function useDebounced<T>(value: T, delayMs = 200): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return debounced;
}
